import axios from 'axios'
import { normalizeSecureFileUrl } from '../utils/secureFileUrl'

function setCsrfHeaders () {
  const token = document.querySelector('meta[name="csrf-token"]')
  if (token) {
    axios.defaults.headers['x-csrf-token'] = token.getAttribute('content')
  }
  axios.defaults.headers.common['Accept'] = 'application/json'
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
}

export default {
  methods: {
    normalizeSecureFileUrl,

    async fetchSecureFileUrl (resourceType, id, attachment = null) {
      setCsrfHeaders()
      let path = `/secure_files/${resourceType}/${id}`
      if (attachment) {
        path += `?attachment=${encodeURIComponent(attachment)}`
      }
      const response = await axios.get(path)
      return response.data && response.data.url
    },

    async openSecureFileUrl (url, options = {}) {
      const { resourceType, id, attachment } = options
      let fileUrl = normalizeSecureFileUrl(url)

      if (!fileUrl && resourceType && id) {
        fileUrl = await this.fetchSecureFileUrl(resourceType, id, attachment)
      }

      if (fileUrl) {
        window.open(fileUrl, '_blank')
      }
    }
  }
}
